ready(function(){

	function updateAnimationProperties() {
		const flashnewsItems = document.querySelectorAll('.animate-flashnews li');
		const flashnewsArr = Array.from(flashnewsItems);
		const initialValue = 0;
		const sumWithInitial = flashnewsArr.reduce((accumulator, currentValue) => accumulator + currentValue.offsetWidth, initialValue,
		);
		document.documentElement.style.setProperty('--flashnews-width', `${-sumWithInitial}px`);
	}

	updateAnimationProperties();

	document.addEventListener('DOMContentLoaded', function() {
		updateAnimationProperties();
	});

	window.addEventListener('resize', function() {
		updateAnimationProperties();
	});	

});